import { createContext, useContext, useEffect, useMemo, useState } from "react";
import { api, setAuthBearer } from "../lib/api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Session lives in an httpOnly cookie. Ask the server who we are — 401 just means logged-out.
    api.get("/auth/me")
      .then((r) => setUser(r.data))
      .catch(() => setUser(null))
      .finally(() => setLoading(false));
  }, []);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    // Backend sets an httpOnly cookie AND returns the token in the body.
    // Store the token in memory as a bearer fallback for environments where the
    // cookie can't be relied on (e.g., proxied origins where SameSite=Lax blocks
    // cross-site XHR). The token is NEVER persisted to localStorage.
    if (data.token) setAuthBearer(data.token);
    setUser(data.user);
    return data.user;
  };

  const logout = async () => {
    try { await api.post("/auth/logout"); } catch { /* best-effort */ }
    setAuthBearer(null);
    setUser(null);
  };

  const value = useMemo(
    () => ({ user, loading, login, logout, setUser }),
    [user, loading]
  );

  return <AuthCtx.Provider value={value}>{children}</AuthCtx.Provider>;
}

export const useAuth = () => useContext(AuthCtx);
